import ServiceModel   from '@models/ServiceModel';
import ApiConnectorV4 from '@/models/ApiConnectorV4';

const services = window.APP_CONFIG?.services || [];
const service = services.find(service => service.id === 'map');

export const mapConnector = new ApiConnectorV4({ baseURL: service?.configurations.api_endpoint });

export default class MapServiceModel extends ServiceModel {
	public static get connector() {
		return mapConnector;
	}

	public static serviceName = 'map';
	public static partitionName = '$';
}
